import styled from '@emotion/styled';
import colors from '../Theme/colors';

const CardBadge = styled.div`
  position: absolute;
  top: -14px;
  left: 50%;
  transform: translateX(-50%);
  height: 28px;
  border-radius: 14px;
  padding: 0 16px;
  background-color: ${colors.black};
  color: ${colors.white};
  font-size: 0.875rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
`;

export default CardBadge;
